exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown {\n  position: relative; }\n  .dropdown__toggle {\n    background-color: #fff;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    border: 1px solid #ccc;\n    width: 100%;\n    text-align: left; }\n    .dropdown__toggle i {\n      float: right; }\n    .dropdown__toggle--item {\n      display: inline-block;\n      background-color: #408bfc;\n      color: #fff;\n      padding: 2px 4px;\n      margin: 2px;\n      border-radius: 2px; }\n  .dropdown__show {\n    position: absolute;\n    right: 0;\n    width: 22rem;\n    max-height: 20rem;\n    padding: 4px;\n    overflow: auto;\n    background-color: #fff;\n    border: 1px solid #bababa;\n    z-index: 100;\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n    margin-left: 1px; }\n    .dropdown__show label {\n      display: block;\n      font-size: 15px;\n      cursor: pointer; }\n    .dropdown__show label input {\n      vertical-align: top; }\n    .dropdown__show label span {\n      display: inline-block; }\n  .dropdown__group-label {\n    display: block;\n    margin-bottom: .5rem;\n    font-size: 1.2rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/multi-select/multi-select.component.scss
// module id = 977
// module chunks = 1